export default {
    risk_group_array: [
        {
            "enum_no": 1,
            "group_name": ["Threats On","Data Breach"],
            "sub_risks": [
                {
                    "enum_no": 1,
                    "risk_name": ["Stolen Password","(Direct - Clients)"],
                    "graph_value": 1
                },
                {
                    "enum_no": 2,
                    "risk_name": ["Stolen Password","(3rd Party)"],
                    "graph_value": 2,
                },
                {
                    "enum_no": 16,
                    "risk_name": ["Stolen Password","(Direct - Employees)"],
                    "graph_value": 3
                }
            ]
        },
        {
            "enum_no": 2,
            "group_name": ["Threats On","Endpoints"],
            "sub_risks": [
                {
                    "enum_no": 10,
                    "risk_name": "Botnet Member",
                    "graph_value": 1
                }
            ]
        },
        {
            "enum_no": 3,
            "group_name": ["Threats On","Servers"],
            "sub_risks": [
                {
                    "enum_no": 6,
                    "risk_name": "Malware Hosting",
                    "graph_value": 2
                },
                {
                    "enum_no": 15,
                    "risk_name": "PUA Hosting",
                    "graph_value": 7
                },
                {
                    "enum_no": 5,
                    "risk_name": "Phishing Sender",
                    "graph_value": 1
                },
                {
                    "enum_no": 7,
                    "risk_name": "Phishing Hosting",
                    "graph_value": 3
                },
                {
                    "enum_no": 8,
                    "risk_name": "C&C Hosting",
                    "graph_value": 4
                },
                {
                    "enum_no": 12,
                    "risk_name": "Spam Site Hosting",
                    "graph_value": 5
                },
                {
                    "enum_no": 14,
                    "risk_name": ["Compromised or","Hostile Servers"],
                    "graph_value": 6
                }
            ]
        },
        {
            "enum_no": 4,
            "group_name": ["Threats On","Network Security"],
            "sub_risks": [
                {
                    "enum_no": 4,
                    "risk_name": "Targeted Phishing",
                    "graph_value": 2
                },
                {
                    "enum_no": 9,
                    "risk_name": "Phishing Received",
                    "graph_value": 3,
                },
                {
                    "enum_no": 3,
                    "risk_name": "Targeted Malware",
                    "graph_value": 1
                }
            ]
        },
        {
            "enum_no": 5,
            "group_name": ["Threats On","Brand & User"],
            "sub_risks": [
                {
                    "enum_no": 13,
                    "risk_name": "Deceptive Site",
                    "graph_value": 1
                }
            ]
        }
    ],
}



// WEBPACK FOOTER //
// ./src/components/threat-timeline/const.js